<template>
    <div style="width: 100%" class="avoid-break">
        <div class="row" style="line-height: 2.5">
            <div class="col m4" style="text-transform: uppercase;">{{$t('inspection.measurement_method')}}</div>
            <div class="col m3">
                <select :disabled=!edit v-model="criterium.method">
                    <option value="standard">{{$t('devices.standard')}}</option>
                    <option value="pests_quantity">{{$t('devices.pest_amount')}}</option>
                    <option value="substance_consumed">{{$t('devices.substance_consumed')}} %</option>
                    <option value="logic_value">{{$t('devices.logic_value')}}</option>
                </select>
            </div>
        </div>
        <div class="row grey" style="width: 100%; padding: 15px 0px;">
            <div class="col s2">
                {{$t('devices.no_activity')}} <br />({{$t('routine_analyses.zero_points')}})
            </div>
            <div class="col s2">
                {{$t('devices.low_activity')}} <br /> ({{$t('routine_analyses.one_point')}})
            </div>
            <div class="col s2">
                {{$t('devices.average_activity')}} <br /> ({{$t('routine_analyses.two_points')}})
            </div>
            <div class="col s2">
                {{$t('devices.high_activity')}} <br />({{$t('routine_analyses.three_points')}})
            </div>
            <div class="col s2">
                {{$t('devices.very_high_activity')}} <br />({{$t('routine_analyses.four_points')}})
            </div>
            <div class="col" :class="{ s1: has_disaster_point, s2: !has_disaster_point }">
                {{$t('devices.critical_point')}}
            </div>
            <div class="col s1" v-if="from_zone && has_disaster_point">
                {{$t('devices.catastrophal_point')}}
            </div>
        </div>
        <div class="row grey" style="width: 100%;" v-if="criterium.method == 'standard'">
            <div class="col s2 input-field inline">
                <input :disabled=!edit v-model="criterium.no_activity_text" />
            </div>
            <div class="col s2 input-field inline">
                <input :disabled=!edit v-model="criterium.low_activity_text" />
            </div>
            <div class="col s2 input-field inline">
                <input :disabled=!edit v-model="criterium.medium_activity_text" />
            </div>
            <div class="col s2 input-field inline">
                <input :disabled=!edit v-model="criterium.high_activity_text" />
            </div>
            <div class="col s2 input-field inline">
                <input :disabled=!edit v-model="criterium.very_high_activity_text" />
            </div>
            <div class="col input-field inline" :class="{ s1: has_disaster_point, s2: !has_disaster_point }">
                <input :disabled=!edit v-model="criterium.critical_point" max="4" min="0" step=".1" type="number" />
            </div>
            <div class="col s1 input-field inline" v-if="from_zone && has_disaster_point">
                <input :disabled=!edit v-model="criterium.disaster_point" style="width: 47px;" />
            </div>
            <div class="col s6 right-align" style="line-height: 2.5">{{$t('devices.critical_disaster')}}</div>
            <div id="critical_disaster_calculation_method" class="col s6">
                <select :disabled=!edit v-model="criterium.critical_calculation">
                    <option value="anyof">{{$t('devices.each_device')}}</option>
                    <option value="avg">{{$t('devices.average_devices')}}</option>
                </select></div>
        </div>
        <template v-if="criterium.method == 'pests_quantity'">
            <div class="row grey" style="width: 100%;">
                <div class="col s2 input-field inline">
                    <input :disabled=!edit value="0" type="number" style="width: 47px;" disabled=""> szt.
                </div>
                <div class="col s2 input-field inline">
                    <input :disabled=!edit value="1" type="number" style="width: 47px;" disabled=""> &#8212;
                    <input :disabled=!edit v-model="criterium.medium_activity_thresold" type="number" style="width: 47px;" /> szt.
                </div>
                <div class="col s2 input-field"><input :disabled=!edit :value="parseInt(criterium.medium_activity_thresold, 10) + 1" type="number" style="width: 47px;" disabled=""> &#8212;
                    <input :disabled=!edit v-model="criterium.high_activity_thresold" type="number" style="width: 47px;" /> szt.
                </div>
                <div class="col s2 input-field">
                    <input :disabled=!edit :value="parseInt(criterium.high_activity_thresold, 10) + 1" type="number" style="width: 47px;" disabled=""> &#8212;
                    <input :disabled=!edit v-model="criterium.very_high_activity_thresold" type="number" style="width: 47px;" /> szt.
                </div>
                <div class="col s2 input-field inline">
                    {{$t('devices.over')}} <input :disabled=!edit v-model="criterium.very_high_activity_thresold" type="number" style="width: 47px;" disabled="" /> szt.
                </div>
                <div class="col input-field inline" :class="{ s1: has_disaster_point, s2: !has_disaster_point }">
                    <input :disabled=!edit v-model="criterium.critical_point" max="4" min="0" step=".1" type="number" />
                </div>
                <div class="col s1 input-field inline" v-if="from_zone && has_disaster_point">
                    <input :disabled=!edit v-model="criterium.disaster_point" style="width: 47px;" />
                </div>
                <div class="col s6 right-align" style="line-height: 2.5">{{$t('devices.critical_disaster')}}</div>
                <div class="col s6">
                    <select id="critical_disaster_calculation_method" :disabled=!edit v-model="criterium.critical_calculation">
                        <option value="anyof">{{$t('devices.each_device')}}</option>
                        <option value="avg">{{$t('devices.average_devices')}}</option>
                    </select></div>
            </div>
            <div class="row " style="width: 100%; line-height: 2.5; margin-top: 15px;">
                <div class="col s12" v-if="criterium.pests_thresolds != undefined &&  criterium.pests_thresolds.length > 0">
                    {{$t('devices.target_pests')}}:
                </div>
            </div>
            <template v-for="pt in criterium.pests_thresolds">
                <div class="row grey tabel" style="width: 100%; margin-top: 15px; padding-top: 5px;">
                    <div class="col s1"> {{$t('devices.pest')}}</div>
                    <div class="col s3">
                          <itemorgroupselector
                            :pestsgroups="pestsByCategory"
                            v-bind:pest_id.sync="pt.pest_id"
                            v-bind:group_id.sync="pt.group_id" :disabled="true"
                          />
                    </div>
                    <div class="col s3"></div>
                </div>
                <div class="row grey" style="width: 100%;  ">
                    <div class="col s2">
                        {{$t('devices.no_activity')}} ({{$t('routine_analyses.zero_points')}})
                    </div>
                    <div class="col s2">
                        {{$t('devices.low_activity')}} ({{$t('routine_analyses.one_point')}})
                    </div>
                    <div class="col s2">
                        {{$t('devices.average_activity')}} ({{$t('routine_analyses.two_points')}})
                    </div>
                    <div class="col s2">
                        {{$t('devices.high_activity')}} ({{$t('routine_analyses.three_points')}})
                    </div>
                    <div class="col s2">
                        {{$t('devices.very_high_activity')}} ({{$t('routine_analyses.four_points')}})
                    </div>
                    <div class="col" :class="{ s1: has_disaster_point, s2: !has_disaster_point }">
                        {{$t('devices.critical_point')}}
                    </div>
                    <div class="col s1" v-if="has_disaster_point">
                        {{$t('devices.catastrophal_point')}}
                    </div>
                </div>
                <div class="row grey tabel" style="width: 100%; margin-bottom: 15px;">
                    <div class="col s2">
                        {{$t('devices.no_pest')}}
                    </div>
                    <div class="col s2 input-field"> 1 szt. &#8212;
                        <input :disabled=!edit v-model="pt.medium_activity_thresold" type="number" style="width: 47px;" /> szt.
                    </div>
                    <div class="col s2 input-field">
                        {{parseInt(pt.medium_activity_thresold, 10) + 1}} &#8212; <input :disabled=!edit v-model="pt.high_activity_thresold" type="number" style="width: 47px;" /> szt.
                    </div>
                    <div class="col s2 input-field">
                        {{parseInt(pt.high_activity_thresold, 10) + 1}} &#8212; <input :disabled=!edit v-model="pt.very_high_activity_thresold" type="number" style="width: 47px;" /> szt.
                    </div>
                    <div class="col s2 input-field">
                        {{$t('devices.above')}} {{parseInt(pt.very_high_activity_thresold, 10) + 1}} szt.
                    </div>
                    <div class="col input-field inline" :class="{ s1: has_disaster_point, s2: !has_disaster_point }">
                        <input :disabled=!edit v-model="pt.critical_point" max="4" min="0" step=".1" type="number" />
                    </div>
                    <div class="col input-field inline" :class="{ s1: has_disaster_point, s2: !has_disaster_point }" v-if="from_zone && has_disaster_point">
                        <input :disabled=!edit v-model="pt.disaster_point" />
                    </div>
                    <div class="col s6 right-align" style="line-height: 2.5">{{$t('devices.critical_disaster')}}</div>
                    <div class="col s6">
                        <select id="critical_disaster_calculation_method" :disabled=!edit v-model="pt.critical_calculation">
                            <option value="max">{{$t('devices.each_device')}}</option>
                            <option value="median">{{$t('devices.median_devices')}}</option>
                            <option value="anyof">{{$t('devices.sum_devices')}}</option>
                            <option value="avg">{{$t('devices.average_devices')}}</option>
                        </select></div>
                </div>
            </template>
            <div class="row" style="width: 100%; padding-top: 15px; padding-bottom: 15px; line-height: 2.5">
                <div class="col s5 input-field"><a class="btn green" v-if="edit" v-on:click="addTargetPest(criterium)">{{$t('devices.add_target_pest')}}</a></div>
            </div>
        </template>
        <div class="row grey tabel" style="width: 100%;" v-if="criterium.method == 'substance_consumed'">
            <div class="col s2 input-field ">
                {{$t('devices.no_pest')}}
            </div>
            <div class="col s2 input-field" style="padding-top: 5px;">
                1 --
                <input :disabled=!edit v-model="criterium.medium_activity_thresold" style="width: 47px;" /> %
            </div>
            <div class="col s2 input-field " style="padding-top: 5px;">
                {{parseInt(criterium.medium_activity_thresold) + 1}}
                --
                <input :disabled=!edit v-model="criterium.high_activity_thresold" style="width: 47px;" />
            </div>
            <div class="col s2 input-field " style="padding-top: 5px;">
                {{parseInt(criterium.high_activity_thresold) + 1}}
                --
                <input :disabled=!edit v-model="criterium.very_high_activity_thresold" style="width: 47px;" /> %
            </div>
            <div class="col s2 input-field" style="padding-top: 5px;">{{parseInt(criterium.very_high_activity_thresold + 1, 10)}} -- 100%</div>
            <div class="col input-field" :class="{ s1: has_disaster_point, s2: !has_disaster_point }">
                <input :disabled=!edit v-model="criterium.critical_point" max="4" min="0" step=".1" type="number" />
            </div>
            <div class="col s1 input-field" v-if="from_zone && has_disaster_point">
                <input :disabled=!edit v-model="criterium.disaster_point" style="width: 47px;" />
            </div>
            <div class="col s6 right-align" style="line-height: 2.5">{{$t('devices.critical_disaster')}}</div>
            <div class="col s6">
                <select :disabled=!edit v-model="criterium.critical_calculation">
                    <option value="max">{{$t('devices.each_device')}}</option>
                    <option value="avg">{{$t('devices.average_devices')}}</option>
                </select></div>
        </div>
        <div class="row grey" style="width: 100%;" v-if="criterium.method == 'logic_value'">
            <div class="col s2 input-field inline">
                {{$t('devices.no_pest')}}
            </div>
            <div class="col s2 input-field inline">
            </div>
            <div class="col s2 input-field inline"></div>
            <div class="col s2 input-field inline">
            </div>
            <div class="col s2 input-field inline">
                {{$t('routine_analyses.one_pest')}}
            </div>
            <div class="col input-field" :class="{ s1: has_disaster_point, s2: !has_disaster_point }">
                <input :disabled=!edit v-model="criterium.critical_point" max="4" min="0" step=".1" type="number" />
            </div>
            <div class="col s1 input-field" v-if="from_zone && has_disaster_point">
                <input :disabled=!edit v-model="criterium.disaster_point" style="width: 47px;" />
            </div>
            <div class="col s6 right-align" style="line-height: 2.5">{{$t('devices.critical_disaster')}}</div>
            <div class="col s6">
                <select :disabled=!edit v-model="criterium.critical_calculation">
                    <option value="max">{{$t('devices.each_device')}}</option>
                    <option value="median">{{$t('devices.median_devices')}}</option>
                    <option value="anyof">{{$t('devices.sum_devices')}}</option>
                    <option value="avg">{{$t('devices.average_devices')}}</option>
                </select>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
export default {
    props: {
        criterium: {},
        pests: [],
        edit: {
            default: false
        },
        from_zone: {
            default: false
        },
        has_disaster_point: {
            default: false
        }
    },
    computed: {
        pestsByCategory() {
            return _.groupBy(_.sortBy(this.pests, 'name'), 'group_name')
        }
    }
}
</script>
<style scoped>
select {
    display: block;
    background-color: white !important;
    border-radius: 4px !important;
    border-width: 1px !important;
    border-style: solid !important;
    border-color: rgb(140, 140, 140) !important;
    padding-left: 5px !important;
    height: 35px !important;
}
</style>
